import axios from 'axios';
import getConfig from '../config';

const { mapURL } = getConfig();

const ApiMap = () => {
  const api = axios.create({
    baseURL: mapURL,
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      access_token: process.env.REACT_APP_MAP_KEY,
    },
  });

  return api;
};

const getInfoForMap = (lat, lng) => ApiMap()
  .get(`mapbox.places/${lng},${lat}.json`)
  .then((data) => data.data)
  .catch((err) => {
    console.error(err);
    return false;
  });

const getRegionNameFromPosition = async (center) => {
  const place = await getInfoForMap(center[1], center[0]);
  let placeName = 'Not Found';
  let shortCode = '';
  if (place.features.length > 0) {
    placeName = place.features[0].place_name.split(',').splice(-2).join().trim();
    shortCode = place.features.slice(-1)[0].properties.short_code;
  }
  return { placeName, shortCode };
};

const wrapperAPI = {
  API: ApiMap(),
  getInfoForMap,
  getRegionNameFromPosition,
};

export default wrapperAPI;
